// define pure helper function use in the project
import dayjs from "dayjs";
import { store } from "../services/redux/store";
import CryptoJS from "crypto-js";

export const getQueryString = (queryParams: any) => {
  let queryParamsString = "";
  const params: string[] = Object.keys(queryParams);
  params.forEach((param: any, index: number) => {
    if (index == 0) {
      queryParamsString += `?${param}=${queryParams[param]}`;
    } else {
      queryParamsString += `&${param}=${queryParams[param]}`;
    }
  });
  return queryParamsString;
};

export const loginTypeData = (userData: any) => {
  if (userData?.loginType === "cif") return userData?.cif;
  else if (userData?.loginType === "phone") return userData?.mobile;
  else if (userData?.loginType === "email") return userData?.email;
  else return null;
};

export const timeSymbolToMilliseconds = (timeOut: string) => {
  const timeNumber: number = Number(timeOut.slice(0, 1));
  const timeSymbol: string = timeOut.slice(1, 2);
  if (timeSymbol.includes("s")) {
    return 1000 * timeNumber;
  } else if (timeSymbol.includes("m")) {
    return 1000 * 60 * timeNumber;
  } else if (timeSymbol.includes("h")) {
    return 1000 * 60 * 60 * timeNumber;
  }
};

export const encodeToBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader?.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader?.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

export const dateToFinYearOptions = (fromDate: string, toDate?: string) => {
  type optionsType = {
    label: string;
    value: string;
  };

  let finYearsOptions: Array<optionsType> = [];
  let finYearsCount: number = 0;

  type finYearType = {
    year: number;
    month: number;
  };

  const fromFinYear: finYearType = {
    year: +dayjs(fromDate).format("YY"),
    month: +dayjs(fromDate).format("MM"),
  };
  const toFinYear: finYearType = {
    year: +dayjs(toDate && toDate).format("YY"),
    month: +dayjs(toDate && toDate).format("MM"),
  };

  if (toFinYear?.year > fromFinYear?.year) {
    finYearsCount = toFinYear?.year - fromFinYear?.year;
    // from date month count less then or equal to 3 then add one more previous fin year
    if (fromFinYear?.month <= 3) {
      finYearsCount = finYearsCount + 1; // add one more fin year
      fromFinYear.year = fromFinYear.year - 1; // start from 1 fin year previous
    }
    // // to month greater then 3 add one more fin year
    if (toFinYear?.month > 3) {
      finYearsCount = finYearsCount + 1;
    }
  } else if (toFinYear?.year == fromFinYear?.year) {
    // from date month count less then or equal to 3 then add one more previous fin year
    if (fromFinYear?.month <= 3) {
      finYearsCount = finYearsCount + 1; // add one more fin year
      fromFinYear.year = fromFinYear.year - 1; // start from 1 fin year previous
    }
    // to date value month greater then 3 add one more fin year
    if (toFinYear?.month > 3) {
      finYearsCount = finYearsCount + 1;
    }
  }

  for (let index: number = 0; index < finYearsCount; index++) {
    finYearsOptions.push({
      label: `FY${fromFinYear.year + index}-${fromFinYear.year + index + 1}`,
      value: `20${fromFinYear.year + index}`,
    });
  }

  return finYearsOptions;
};

export const capitalizeFirstLetter = (str: string) => {
  return str?.charAt(0).toUpperCase() + str?.toLowerCase().slice(1);
};

export const termLoanPermissionCheck = () => {
  const userLoanCategory = store?.getState()?.auth?.loanCategory;
  const userBusinessSelected = store?.getState()?.auth?.businessType;
  if (userLoanCategory && userBusinessSelected) {
    const selectedLoanCategoryObj = userLoanCategory?.TermLoan?.find(
      (loan: any) => loan?.businessId === userBusinessSelected?.id
    );
    return selectedLoanCategoryObj?.permissionBypass;
  } else {
    return false;
  }
};

export const flexiLoanPermissionCheck = () => {
  const userLoanCategory = store?.getState()?.auth?.loanCategory;
  const userBusinessSelected = store?.getState()?.auth?.businessType;
  if (userLoanCategory && userBusinessSelected) {
    const selectedLoanCategoryObj = userLoanCategory?.Flexi?.find(
      (loan: any) => loan?.businessId === userBusinessSelected?.id
    );
    return selectedLoanCategoryObj?.permissionBypass;
  } else {
    return false;
  }
};

export const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  // Prevent non-numeric input
  if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
    e.preventDefault();
  }
};
export const getInitials = (text: any) => {
  const words = text.trim().split(" ");
  const firstLetter = words[0][0]; // First letter of the first word
  const lastLetter = words[words.length - 1][0]; // First letter of the last word
  return `${firstLetter}${lastLetter}`.toUpperCase(); // Combine and make uppercase
};

export const PositiveNumberValidation = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const charCode = event.key;

  // Allow only digits, backspace, and delete
  if (
    !/[0-9]/.test(charCode) &&
    charCode !== "Backspace" &&
    charCode !== "Delete"
  ) {
    event.preventDefault();
  }
};
// Function to mask mobile numbers
export function maskMobile(mobile: any) {
  if (!mobile || typeof mobile !== "string" || mobile.length < 4) {
    return "Invalid mobile number"; // Handle null, undefined, or invalid input
  }
  // Mask all but the last 4 digits
  return "xxxxxx" + mobile.slice(-4);
}

// Function to mask email addresses
export function maskEmail(email: any) {
  if (!email || typeof email !== "string" || !email.includes("@")) {
    return "Invalid email address"; // Handle null, undefined, or invalid input
  }

  // Split into the local part and domain
  const [localPart, domain] = email.split("@");
  if (!localPart || !domain) {
    return "Invalid email address"; // Additional safety checks
  }

  // Show only the first 3 characters of the local part
  const maskedLocal = localPart.slice(0, 3) + "xxxxxxx";
  return `${maskedLocal}@${domain}`;
}
export function maskEmailOrMobile(data: any) {
  const mobilePattern = /^\d{10}$/; // Pattern for 10-digit mobile number
  const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/; // Pattern for email

  if (mobilePattern.test(data)) {
    // Check if the input is a mobile number
    return "*".repeat(6) + data.slice(-4); // Mask first 6 digits
  } else if (emailPattern.test(data)) {
    // Check if the input is an email address
    const [name, domain] = data.split("@");
    // Mask email name except for the first three characters
    const maskedName = name.slice(0, 3) + "*".repeat(name.length - 3);
    return `${maskedName}@${domain}`; // Return masked email address
  } else {
    return "Invalid input"; // Handle invalid input
  }
}
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Secure navigation utility to prevent open redirect attacks
 * @param path - The path to navigate to
 * @param navigate - React Router's navigate function
 * @param fallbackPath - Optional fallback path if validation fails (defaults to '/dashboard')
 * @returns boolean - true if navigation was successful, false if validation failed
 */
export const secureNavigate = (
  path: string,
  navigate: (path: string) => void,
  fallbackPath: string = '/dashboard'
): boolean => {
  // Validate the path to prevent open redirect attacks
  if (!path) {
    console.warn('Navigation path is empty or undefined');
    return false;
  }

  // Only allow internal paths (starting with /)
  if (path.startsWith('/') && !path.includes('://')) {
    // Additional validation: ensure path doesn't contain suspicious patterns
    const suspiciousPatterns = [
      /javascript:/i,
      /data:/i,
      /vbscript:/i,
      /on\w+\s*=/i, // event handlers
      /<script/i,   // script tags
    ];

    const hasSuspiciousPattern = suspiciousPatterns.some(pattern => pattern.test(path));

    if (hasSuspiciousPattern) {
      console.warn('Suspicious navigation path detected:', path);
      return false;
    }

    // Path is safe, proceed with navigation
    navigate(path);
    return true;
  } else {
    console.warn('Invalid navigation path detected (potential open redirect):', path);

    // Optionally redirect to fallback path
    if (fallbackPath && fallbackPath.startsWith('/')) {
      navigate(fallbackPath);
    }

    return false;
  }
};

/**
 * Maps gender codes to their full names and vice versa
 * @param input - Gender code (F, M, O, T) or full name (Female, Male, Other, Transgender)
 * @returns The corresponding full name or code, or the original input if no match found
 */
export const mapGender = (): any => {
  const genderArray = [
    { code: 'F', name: 'Female' },
    { code: 'M', name: 'Male' },
    { code: 'O', name: 'Other' },
    { code: 'T', name: 'Prefer Not To Say' }
  ];

  return genderArray;
};

// Removes leading salutations/relationships like "S/O", "S.O", "Son of"
export function removeSalutation(fullName: string) {
  if (!fullName) return "";
  // Match at start: S/O, S.O, or "Son of" (case-insensitive), with optional spaces/punctuation
  const salutationRegex = new RegExp(
    // start of string ^
    '^\\s*(' +
    's\\s*[/.-]?\\s*o' +           // S/O, S.O
    '|son\\s+of' +                 // Son of
    '|d\\s*[/.-]?\\s*o' +          // D/O, D.O
    '|daughter\\s+of' +            // Daughter of
    '|w\\s*[/.-]?\\s*o' +          // W/O, W.O
    '|wife\\s+of' +                // Wife of
    '|c\\s*[/.-]?\\s*o' +          // C/O, C.O
    '|care\\s+of' +                // Care of
    '|f\\s*[/.-]?\\s*o' +          // F/O (Father of)
    '|father\\s+of' +              // Father of
    '|m\\s*[/.-]?\\s*o' +          // M/O (Mother of)
    '|mother\\s+of' +              // Mother of
    ')[:\\s-]*',                     // optional colon/space/hyphen
    'i'
  );
  const cleanedName = fullName.replace(salutationRegex, "");
  return cleanedName.trim();
}

export const formatDOB = (value: number | string) => {
  if (!value) return "-";

  // Case 1: YYYY-MM-DD string
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-");
    return `${day}-${month}-${year}`;
  }

  // Case 2: timestamp (number or numeric string)
  const date = new Date(Number(value));
  if (isNaN(date.getTime())) return "-";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

/** Mask PAN for display: first 5 chars + **** + last char (e.g. AZCPN****R) */
export const maskPan = (pan: string | undefined | null): string => {
  if (!pan || typeof pan !== "string") return pan ?? "";
  const s = String(pan).trim().toUpperCase();
  if (s.length <= 6) return s;
  return s.slice(0, 5) + "****" + s.slice(-1);
};

export const toAbsoluteUrl = (url: string) => {
  if (!url) return "";

  // already absolute
  if (/^(https?:)?\/\//i.test(url)) return url.startsWith("//")
    ? `https:${url}`
    : url;

  // plain domain -> make https
  return `https://${url}`;
};


export const formatDateToDDMMYYYY = (date: string) => {
  return new Date(date)
    .toLocaleDateString("en-GB", { timeZone: "Asia/Kolkata" })
    .replace(/\//g, "-");
};

export function debounce(fn: (...args: any[]) => void, delay: number) {
  let timer: any;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

export const handleOwnershipStatusValue = (value: any) => {
  switch (value) {
    case "Rented":
      return 276;
    case "Owned":
      return 277;
  }
};

/** Resolve birthCityId code from stored field value + city master options. */
export const resolveBirthCityId = (
  raw: any,
  cityOptions: Array<{ value?: string | number; label?: string }> = [],
): string => {
  if (raw === null || raw === undefined || raw === "") return "";

  const rawValue =
    raw && typeof raw === "object" ? String(raw?.value ?? "").trim() : String(raw ?? "").trim();
  const rawLabel =
    raw && typeof raw === "object"
      ? String(raw?.label ?? raw?.value ?? "").trim()
      : String(raw ?? "").trim();

  const matched = (cityOptions || []).find((opt) => {
    const optValue = String(opt?.value ?? "").trim().toLowerCase();
    const optLabel = String(opt?.label ?? "").trim().toLowerCase();
    return (
      (rawValue &&
        (optValue === rawValue.toLowerCase() || optLabel === rawValue.toLowerCase())) ||
      (rawLabel &&
        (optValue === rawLabel.toLowerCase() || optLabel === rawLabel.toLowerCase()))
    );
  });

  // Only a genuine match against the city master list is a verified city
  // code — an unmatched raw value can be a label, or even a country name
  // when city master data is missing for that country, so it must never be
  // sent as the birthCityId payload value.
  return matched ? String(matched.value ?? "").trim() : "";
};

export const handleUnwanted = (str: string): string => {
  if (str === "-") return "";
  // Remove special characters except spaces, hyphens, and apostrophes
  return str;
}


export const splitAddressByWords = (text: string) => {
  const maxLen = 50;
  const maxLines = 3;

  const words = text.split(" ");
  const lines: string[] = [];
  let currentLine = "";

  for (const word of words) {
    const nextLine = currentLine
      ? `${currentLine} ${word}`
      : word;

    if (nextLine.length > maxLen) {
      lines.push(currentLine.trim());
      currentLine = word;

      if (lines.length === maxLines) break;
    } else {
      currentLine = nextLine;
    }
  }

  if (lines.length < maxLines && currentLine) {
    lines.push(currentLine.trim());
  }

  return lines;
};

/**
 * Identifies whether a co-owner's selected name matches the main applicant or
 * one of the loan's co-applicants, so save-collateral can attach that specific
 * person's own applicantId instead of reusing the main applicant's id for every
 * co-owner row.
 */
export const matchCoOwnerNameToApplicant = (
  formValues: Record<string, any>,
  selectedName: string,
): { type: "main" } | { type: "coApplicant"; coApplicantNumber: number } | null => {
  const normalizedSelected = String(selectedName || "").trim();
  if (!normalizedSelected) return null;

  const mainFirst =
    formValues?.firstName || formValues?.studentDetailsFirstName || "";
  const mainLast = formValues?.lastName || formValues?.studentDetailsLastName || "";
  const mainName = [mainFirst, mainLast].filter(Boolean).join(" ");
  if (mainName && normalizedSelected === mainName) return { type: "main" };

  for (let ci = 1; ci <= 10; ci++) {
    const coFirst = formValues?.[`basicCoApplicant${ci}FirstName`];
    if (!coFirst) break;
    const coLast = formValues?.[`basicCoApplicant${ci}LastName`] || "";
    const coName = [coFirst, coLast].filter(Boolean).join(" ");
    if (normalizedSelected === coName) {
      return { type: "coApplicant", coApplicantNumber: ci };
    }
  }

  return null;
};

// Flattens every horizontalSteps[].verticalSteps[].fields[] entry of the
// fetch-application-data response into one { fieldName: value } map.
export const extractFetchedApplicationVals = (
  fetchUserApplicationData: any,
): Record<string, any> => {
  const fetchedVals: Record<string, any> = {};
  const steps = fetchUserApplicationData?.horizontalSteps;
  if (!Array.isArray(steps)) return fetchedVals;
  steps.forEach((step: any) => {
    (step?.verticalSteps || []).forEach((vStep: any) => {
      (vStep?.fields || []).forEach((field: any) => {
        if (!field || typeof field !== "object") return;
        Object.keys(field).forEach((key) => {
          fetchedVals[key] = field[key];
        });
      });
    });
  });
  return fetchedVals;
};

// Co-applicant First Name / Last Name / Mobile are locked once that
// co-applicant is used as a collateral co-owner (co-owner name matches the
// co-applicant's "first last" name and the co-owner's phone is the
// co-applicant's phone), so the co-owner link can't break. `savedValues`
// should be saved data (fetched/redux), not live Formik edits.
export const isCoApplicantFieldLockedByCoOwner = (
  savedValues: Record<string, any>,
  fieldName: string,
): boolean => {
  const match = String(fieldName || "").match(
    /^basicCoApplicant(\d+)(FirstName|LastName|PhoneNumber)$/,
  );
  if (!match) return false;
  const n = Number(match[1]);
  const toValue = (val: any) =>
    val && typeof val === "object" ? val.value ?? val.label ?? "" : val;
  const normalizeName = (val: any) =>
    String(toValue(val) ?? "").trim().replace(/\s+/g, " ").toLowerCase();
  const lastTenDigits = (val: any) =>
    String(toValue(val) ?? "").replace(/\D/g, "").slice(-10);

  // Same name / phone resolution the co-owner Name dropdown uses, so every
  // co-applicant (1, 2, ...) matches exactly what was selected as co-owner.
  const coApplicantName = normalizeName(
    [
      toValue(savedValues?.[`basicCoApplicant${n}FirstName`]),
      toValue(savedValues?.[`basicCoApplicant${n}LastName`]),
    ]
      .filter(Boolean)
      .join(" "),
  );
  const coApplicantPhone = lastTenDigits(
    savedValues?.[`basicCoApplicant${n}PhoneNumber`] ||
      savedValues?.[`basicCoApplicant${n}Phone_number`] ||
      savedValues?.[`basicCoApplicant${n}Phone`] ||
      savedValues?.[`coApplicant${n}Phone_number`],
  );
  if (!coApplicantName || !coApplicantPhone) return false;

  return Object.keys(savedValues || {}).some((key) => {
    if (!/^coOwnerCollateral\d+(?:_\d+)?Name$/i.test(key)) return false;
    if (normalizeName(savedValues[key]) !== coApplicantName) return false;
    const prefix = key.replace(/Name$/i, "");
    return lastTenDigits(savedValues?.[`${prefix}PhoneNumber`]) === coApplicantPhone;
  });
};

export const mapCollateral = (): any => {
  const collateralArray = [
    { value: '307', label: 'Fixed Deposit' },
    { value: '308', label: 'Property' },
    { value: '309', label: 'Saving' },
  ];

  return collateralArray;
};

export const numberToWord: Record<number, string> = {
  1: "ONE",
  2: "TWO",
  3: "THREE",
  4: "FOUR",
  5: "FIVE",
  6: "SIX",
  7: "SEVEN",
  8: "EIGHT",
  9: "NINE",
  10: "TEN",
  11: "ELEVEN",
  12: "TWELVE",
  13: "THIRTEEN",
  14: "FOURTEEN",
  15: "FIFTEEN",
  16: "SIXTEEN",
  17: "SEVENTEEN",
  18: "EIGHTEEN",
  19: "NINETEEN",
  20: "TWENTY"
}

type MaskType = "pan" | "aadhaar" | "mobile";

export const maskValue = (value: string, type: MaskType = 'pan'): string => {
  if (!value) return "";

  switch (type) {
    case "pan":
      // Show first and last characters
      if (value.length <= 2) return value;
      return (
        value[0] +
        "*".repeat(value.length - 2) +
        value[value.length - 1]
      );

    case "aadhaar":
    case "mobile":
      // Show only the last 4 digits
      return value.replace(/\d(?=(?:\D*\d){4})/g, "*");

    default:
      return value;
  }
}
